import type { GameRowValue } from '../../backend.d'
import { createResource, type Accessor } from 'solid-js'
import { backendAxios } from '../../axios'
import type { StateOnlineId } from '../../lib/core/state/StateOnlineId.type'
import { Nullable } from '../../typescript'
import { decodePersistedStateData } from '../../lib/core/state/persisted_state'

async function fetchGameById(stateId: Nullable<StateOnlineId>): Promise<GameRowValue | null> {
  // console.log('fetchGameById', {stateId})
  if (stateId) {
    // console.log(`<backendAxios.get(/st1/game/${stateId})>`)
    const response = await backendAxios.get(`/st1/game/${stateId}`)
    // console.log(`</backendAxios.get(/st1/game/${stateId})>`)
    const row: GameRowValue = response.data
    return {
      ...row,
      data: decodePersistedStateData(row.data),
    } as GameRowValue
  }
  return null
}

export default function createGameRowResource(stateId: Accessor<Nullable<StateOnlineId>>) {
  const resource = createResource(stateId, fetchGameById)
  return resource
}
